import "../../../src/App.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import TaskAssignedToMe from "../../components/TaskAssignedToMe/TaskAssignedToMe";
import AssignTask from "../../components/AssignTask/AssignTask";
import TaskAssignedByMe from "../../components/TaskAssignedByMe/TaskAssignedByMe";

function TaskAssigned() {
  const isAdmin = localStorage.getItem("isAdmin");
  const [supplierDetailResponse, setSupplierDetailResponse] = useState(null);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [activeTab, setActiveTab] = useState("toMe");

  function tokenStorage() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETSupplier?SupplierID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setSupplierDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  useEffect(() => {
    tokenStorage();
  }, []);

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{
            padding: "4rem 1rem 1rem 1rem",
            width: "94%",
            backgroundColor: "#F4F4F4",
          }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Task Assigned
                </h1>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    gap: "1rem",
                  }}
                >
                  <button onClick={() => setActiveTab("toMe")}>
                    Task Assigned To Me
                  </button>
                  <button onClick={() => setActiveTab("byMe")}>
                    Task Assigned By Me
                  </button>
                  <button onClick={() => setActiveTab("assignTask")}>Add Task</button>
                </div>
              </Wrapper>
              <br /><br />
              <div>
                {activeTab === "toMe" && <TaskAssignedToMe />}
                {activeTab === "byMe" && <TaskAssignedByMe />}
                {activeTab === "assignTask" && <AssignTask />}


              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TaskAssigned;
